import { useMemo, useState } from 'react';

export const useIsOtherOccupation = () => {
    const [isOther, setIsOther] = useState(false);

    return {
        isOther,
        setIsOther,
        validationFields: useMemo(() => isOther ? ['occupation', 'otherOccupation'] : ['occupation'], [isOther])
    };
};
